import React from 'react'
import "./css/experience.css"

const Experience = () => {
  return (
    <>
      <h1
        style={{
          color: "rgb(40,116,240)",
          textDecoration: "underline",
          textAlign: "center",
        }}
      >
        Experience
      </h1>
      <div className="experienceparent">
      <div className="experiencemain" id="experience">
        <div className='pearlximgbox'>
            <img className="pearlximg" src="pearlx.png" alt="" />
            <p className='pearlxname'>Pearlx Trader</p>
        </div>

        </div>
        <div className="experiencemain1">
          <div className='experience_date_role'>
            <h4 className="experiencemainp">Full Stack Developer</h4>
            <p>May 2023 - june 2024</p>
          </div>
          <h5 className="experiencemainh">Responsibilities :-</h5>
          <ul className="experiencemainp experince_resp_ul">
            <li>
            Lead developer responsible for both frontend and backend technologies.
            </li>
            <li>
            Designed and developed from scratch the CRM, second third versions of the company's applications, enhancing user experience and functionality.
            </li>
            <li>
            Implemented web socket for the live price to show live P&L and realtime data update on UI.
            </li>
            <li>
            Designed and implemented various functionalities from scratch, including live profit and loss tracking, subscription management, OTP-based user authentication and role based authorization in CRM.
            </li>
            <li>
            Developed and optimized an order placement bot using asynchronous JavaScript, reducing order execution time from 9-10 seconds in the previous bot to just 2-3 seconds and enhancing overall performance.
            </li>
            <li>
            Integrated algo trading APIs to automate order placement directly into customers' demat accounts, streamlining the trading process.

            </li>
          </ul>
        </div>
        </div>
        <div className="experienceparent">
        <div className="experiencemain" id="experience">
          <div className="experiencemain">
            <img className="experienceimg" src="apollo_logo.png" alt="" />
          </div>
        </div>
        <div className="experiencemain1">
          <div className='experience_date_role'>
            <h4 className="experiencemainp">Jr. Full Stack Developer</h4>
            <p>Jan 2023 - Apr 2023</p>
          </div>
          <h5 className="experiencemainh">Responsibilities :-</h5>
          <ul className="experiencemainp experince_resp_ul">
            <li>
              Implemented new features and enhanced existing functionalities
            </li>
            <li>
              Conducted thorough testing and debugging to ensure high-quality
              code and user experience.
            </li>
            <li>
              Collaborated with cross-functional teams to gather requirements
              and ensure seamless integration of new features into existing
              product.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Experience
